import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=31b41f08&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports